<template>
   <div class="charts-container" v-if="dataReady">
      <div class="chart-container" v-for="(chartData, chartIndex) in chartsData" :key="chartIndex">
         <!--<aside class="aside options">-->
         <div class="options-wrapper">
            <div class="column first">
            <ListMetricYears :metricYears="yearsList" :selectedMetricYears="chartData['chartYears']" :monthList="defaultMonthLabels" :chartIndex="chartIndex" @changeMetricDateRange="changeMetricDateRange"></ListMetricYears>
            </div>
            <div class="column last">
            <ListMetricTypes :typeList="metricTypes" :selectedTypes="chartData['selectedTypes']" :chartIndex="chartIndex" @changeType="changeMetricTypes"></ListMetricTypes>
            <ListNodes :nodes="listNodes" :currentNodes="chartData['currentNodes']" :chartIndex="chartIndex" @node="updateNodes"></ListNodes>
            </div>
         </div>
         <div class="share-wrapper">
            <button class="button share" v-if="chartData['showShare']['showButton']" v-on:click="chartData['showShare']['showButton'] = false;chartData['showShare']['showURL'] = true">Share Chart</button>
            <div class="share-url" v-if="chartData['showShare']['showURL']">
               <input type="text" :value="generateShareURL(chartData)" readonly>
               <button class="button action" v-on:click="copyToClipboard(generateShareURL(chartData))">Copy</button>
               <button class="button action" v-on:click="chartData['showShare']['showButton'] = true;chartData['showShare']['showURL'] = false">Close</button>
            </div>
         </div>
         <!--</aside>-->
         <div class="chart-content">
            <MetricChart :chartIndex="chartIndex" :chart-data="chartData['chartData']"></MetricChart>
         </div>
      </div>

      <div class="function-wrapper">
         <button type="button" class="button" v-on:click="add_new_chart()">Add New Chart</button>
      </div>
   </div>
</template>

<script>
import ListNodes from "@/components/ListNodes"
import MetricChart from "@/components/MetricChart"
import ListMetricYears from "@/components/ListMetricYears"
import ListMetricTypes from "@/components/ListMetricTypes"
import * as d3 from "d3-scale-chromatic"

export default {
   name: "Home",
   components: {
      ListNodes,
      MetricChart,
      ListMetricYears,
      ListMetricTypes
   },
   data() {
      return {
         defaultMonthLabels:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
         chartsData: [{
            metricData: {},
            chartYears:{from:{year:"",month:""},to:{year:"",month:""}},
            currentNodes:[],
            selectedTypes:[],
            chartData: {},
            showShare: {
               showButton: true,
               showURL: false
            }
         }],
         //chartData: {},
         listNodes: [],
         //currentNodes: [],
         yearsList:[],
         chartYear:"",
         //metricData: {},
         selectedTypes: ["files"],
         metricTypes:["files","volume","visitors"],
         dataReady: false
      }
   },
   created() {
      let self = this;
      const queryparams = {
         years: this.$route.query.years,
         nodes: this.$route.query.nodes,
         types: this.$route.query.types
      };

      fetch("data/metric-years.json").then(function(response) {
         return response.json();
      }).then(function(response) {
         self.yearsList = response.years;
         let chartData = self.chartsData[0];
         if(queryparams["years"] != undefined) {
            let years_array = queryparams["years"].split(",");
            if(years_array.length == 2) {
               chartData["chartYears"]["from"]["year"] = self.validateIsYear(years_array[0] , response.years[0]);
               chartData["chartYears"]["to"]["year"] = self.validateIsYear(years_array[years_array.length - 1], response.years[0]);
            } else {
               chartData["chartYears"]["from"]["year"] = self.validateIsYear(years_array[0], response.years[0]);
               chartData["chartYears"]["to"]["year"] = self.validateIsYear(years_array[0], response.years[0]);
            }
         } else {
            chartData["chartYears"]["from"]["year"] = response.years[0];
            chartData["chartYears"]["to"]["year"] = response.years[0];
         }

         if(queryparams["nodes"] != undefined) {
            chartData["currentNodes"] = queryparams["nodes"].split(",")
         }

         if(queryparams["types"] != undefined) {
            //validate selected types are valid.  selectedTypes may be coming from queryparam
            const selected_types = self.metricTypes.filter( value => queryparams["types"].split(",").includes(value));
            chartData["selectedTypes"] = selected_types;
         }

         self.loadMetricDateRangeData(0, chartData['chartYears']);
      });

      // fetch("data/metric-years.json").then(function(response) {
      //    return response.json();
      // }).then(function(response) {
      //    self.yearsList = response.years;
      //    self.chartsData[0]["chartYears"]["from"]["year"] = response.years[0];
      //    self.chartsData[0]["chartYears"]["to"]["year"] = response.years[0];
      //    return response.years[0];
      // }).then(function(resposne) {
      //    fetch("data/" + resposne + ".json").then(function(response) {
      //       return response.json();
      //    }).then(function(data) {
      //       const nodes = [];
      //       Object.keys(data).forEach(function(nodeName) {
      //          nodes.push(nodeName);
      //       });
      //       self.listNodes = nodes;
      //       //self.currentNodes.push(nodes[0]);
      //       self.chartsData[0]["currentNodes"].push(nodes[0]);

      //       self.chartsData[0]["metricData"] = data;
      //       self.chartsData[0]["chartData"] = self.generateChartDatasets(self.chartsData[0]["metricData"], self.chartsData[0]["chartYears"]["from"]["year"], self.chartsData[0]["currentNodes"], self.chartsData[0]["selectedTypes"]);

      //       self.dataReady = true;
      //    });
      // });
   },
   methods: {
      async loadMetricDateRangeData(chartIndex, dateRange) {
         let self = this;
         let metricYearsData = {};

         // self.listNodes.forEach(function(node) {
         //    metricYearsData[node] = {"files":[],"volume":[],"visitors":[]}
         // });

         //let year_sort = [dateRange["from"]["year"],dateRange["to"]["year"]], years_array = [];
         const years_array = self.get_years_range(dateRange["from"]["year"],dateRange["to"]["year"]);

         let promises = [], promise_data = [];
         years_array.forEach(function(year){
            promises.push(
               fetch("./data/" + year + ".json").then(function(response) {
                  return response.json();
               }).then(function(data) {
                  console.log(data);
                  promise_data.push(data);
               })
            )
         });

         Promise.all(promises).then(function() {
            promise_data.forEach(function(data) {
               Object.keys(data).forEach(function(nodeName) {
                  if(metricYearsData[nodeName] == undefined) {
                     metricYearsData[nodeName] = {"files":[],"volume":[],"visitors":[]}
                     if(!self.listNodes.includes(nodeName)) self.listNodes.push(nodeName);
                  }
                  if(metricYearsData[nodeName]["files"].length == 0) {
                     metricYearsData[nodeName]["files"] = data[nodeName]["files"]
                  } else {
                     metricYearsData[nodeName]["files"] = metricYearsData[nodeName]["files"].concat(data[nodeName]["files"]);
                  }

                  if(metricYearsData[nodeName]["volume"].length == 0) {
                     metricYearsData[nodeName]["volume"] = data[nodeName]["volume"];
                  } else {
                     metricYearsData[nodeName]["volume"] = metricYearsData[nodeName]["volume"].concat(data[nodeName]["volume"]);
                  }
                  if(metricYearsData[nodeName]["visitors"].length == 0) {
                     metricYearsData[nodeName]["visitors"] = data[nodeName]["visitors"];
                  } else {
                     metricYearsData[nodeName]["visitors"] = metricYearsData[nodeName]["visitors"].concat(data[nodeName]["visitors"]);
                  }
               });
            });

            //validate selected nodes are valid.  currentNodes may be coming from queryparam
            self.chartsData[chartIndex]["currentNodes"] = self.listNodes.filter( value => self.chartsData[chartIndex]["currentNodes"].includes(value));
            self.chartsData[chartIndex]["metricData"] = metricYearsData;
            self.chartsData[chartIndex]["chartData"] = self.generateChartDatasets(self.chartsData[chartIndex]["metricData"], years_array, self.chartsData[chartIndex]["currentNodes"], self.chartsData[chartIndex]["selectedTypes"]);
            self.dataReady = true;
         });
      },
      get_years_range: function(from, to) {
         let year_sort = [from,to], years_array = [];
         year_sort.sort((a, b) => a - b);
         for(let year = year_sort[0]; year <= year_sort[1]; year++) {
            years_array.push(year);
         }
         return years_array;
      },
      updateNodes: function(selectedNode) {
         if(this.chartsData[selectedNode["chartIndex"]]["currentNodes"].includes(selectedNode["node"])) {
            this.chartsData[selectedNode["chartIndex"]]["currentNodes"] = this.chartsData[selectedNode["chartIndex"]]["currentNodes"].filter(item => item != selectedNode["node"]);
         } else {
            this.chartsData[selectedNode["chartIndex"]]["currentNodes"].push(selectedNode["node"]);
         }
         const years_array = this.get_years_range(this.chartsData[selectedNode["chartIndex"]]["chartYears"]["from"]["year"],this.chartsData[selectedNode["chartIndex"]]["chartYears"]["to"]["year"]);

         this.chartsData[selectedNode["chartIndex"]]["chartData"] = this.generateChartDatasets(this.chartsData[selectedNode["chartIndex"]]["metricData"], years_array, this.chartsData[selectedNode["chartIndex"]]["currentNodes"], this.chartsData[selectedNode["chartIndex"]]["selectedTypes"]);
      },
      changeMetricDateRange: function(rangeData) {
         //console.log(range);
         //this.chartYears = range;
         this.chartsData[rangeData["chartIndex"]]["chartYears"] = rangeData["selectedMetricYears"];
         console.log(this.chartsData[rangeData["chartIndex"]]["chartYears"]);
         this.loadMetricDateRangeData(rangeData["chartIndex"], this.chartsData[rangeData["chartIndex"]]["chartYears"]);
      },
      changeMetricTypes: function(selectedType) {
         if(this.chartsData[selectedType["chartIndex"]]["selectedTypes"].includes(selectedType["type"])) {
            this.chartsData[selectedType["chartIndex"]]["selectedTypes"] = this.chartsData[selectedType["chartIndex"]]["selectedTypes"].filter(item => item != selectedType["type"]);
         } else {
            this.chartsData[selectedType["chartIndex"]]["selectedTypes"].push(selectedType["type"]);
         }

         const years_array = this.get_years_range(this.chartsData[selectedType["chartIndex"]]["chartYears"]["from"]["year"],this.chartsData[selectedType["chartIndex"]]["chartYears"]["to"]["year"]);

         this.chartsData[selectedType["chartIndex"]]["chartData"] = this.generateChartDatasets(this.chartsData[selectedType["chartIndex"]]["metricData"], years_array, this.chartsData[selectedType["chartIndex"]]["currentNodes"], this.chartsData[selectedType["chartIndex"]]["selectedTypes"]);
      },
      generateChartDatasets: function(data, years, nodes, types) {
         let datasets = [], colorIndex = 0
         const colorScale = d3.interpolatePlasma;
         const colorRangeInfo = {
            colorStart: 0,
            colorEnd: 0.75,
            useEndAsStart: false
         };
         const chartLines = nodes.length * types.length;
         const COLORS = this.interpolateColors(chartLines, colorScale, colorRangeInfo);
         Object.keys(data).forEach(function(key) {
            if(nodes.includes(key)) {
               let node_data = data[key];
               Object.keys(node_data).forEach(function(type) {
                  if(types.includes(type)) {
                     let label = key + " - " + type.charAt(0).toUpperCase() + type.slice(1);
                     if(type == "volume") label += " (Mbytes)";
                     datasets.push({
                        fill: false,
                        label: label,
                        backgroundColor: COLORS[colorIndex],
                        borderColor: COLORS[colorIndex],
                        data: node_data[type]
                     });
                     colorIndex++;
                  }
               });
            }
         });

         let xAxisLabels = this.defaultMonthLabels;
         if(years.length > 1) {
            let newXAxisLabels = [];
            years.forEach(function(yrValue) {
               xAxisLabels.forEach((label) => newXAxisLabels.push(yrValue + ":" + label));
            });
            xAxisLabels = newXAxisLabels;
         }

console.log({labels:xAxisLabels,datasets:datasets});
         return {labels:xAxisLabels,datasets:datasets};
      },
      calculatePoint: function(i, intervalSize, colorRangeInfo) {
         const { colorStart, colorEnd, useEndAsStart } = colorRangeInfo;
         return (useEndAsStart
            ? (colorEnd - (i * intervalSize))
            : (colorStart + (i * intervalSize)));
      },
      /* Must use an interpolated color scale, which has a range of [0, 1] */
      interpolateColors: function(dataLength, colorScale, colorRangeInfo) {
         const { colorStart, colorEnd } = colorRangeInfo;
         const colorRange = colorEnd - colorStart;
         const intervalSize = colorRange / dataLength;
         let i, colorPoint;
         const colorArray = [];

         for (i = 0; i < dataLength; i++) {
            colorPoint = this.calculatePoint(i, intervalSize, colorRangeInfo);
            colorArray.push(colorScale(colorPoint));
         }

         return colorArray;
      },
      add_new_chart: function() {
         this.chartsData.push({
            metricData: {},
            chartYears:{from:{year:"",month:""},to:{year:"",month:""}},
            currentNodes:[],
            selectedTypes:[],
            chartData: {},
            showShare: {
               showButton: true,
               showURL: false
            }
         });
      },
      generateShareURL: function(chartData) {
         console.log(window.location);
         let years_array = [chartData["chartYears"]["from"]["year"]];
         if(chartData["chartYears"]["from"]["year"] != chartData["chartYears"]["to"]["year"]) years_array.push(chartData["chartYears"]["to"]["year"]);

         console.log(years_array);
         let querystrings = [];
         if(years_array.length > 0) querystrings.push("years=" + years_array.join(","));
         if(chartData["currentNodes"].length > 0) querystrings.push("nodes="+ chartData["currentNodes"].join(","));
         if(chartData["selectedTypes"].length > 0) querystrings.push("types="+ chartData["selectedTypes"].join(","));
         let href_location = window.location.protocol + "//" + window.location.host + window.location.pathname + "#/";
         if(querystrings.length > 0) href_location += "?" + querystrings.join("&");
         return href_location;
      },
      async copyToClipboard(textToCopy) {
         await navigator.clipboard.writeText(textToCopy);
      },
      validateIsYear: function(value, default_value) {
         return (!isNaN(value) ? value : default_value);
      }
   }
}
</script>

<style lang="scss">
@media screen and (min-width: 1200px) {
   .chart-container {
      /*display: flex;*/
      .aside {
         float: left;
         width: 15%;
         text-align: left;
      }
      .chart-content {
         float: left;
         width: 90%;
      }
      &:after {
         content: "";
         display: table;
         clear: both;
      }

   }
   .options-wrapper {
      display: flex;
      .column.first {
         padding-right: 1em;
      }
   }
   .charts-container {
      .share-url {
         /*span { padding: 15px 32px; background-color: #f2f2f2; }*/
         input { padding: 5px 10px; width: 60% }
      }
      .share-wrapper { min-height: 45px; }
      .button {
         background-color: #4CAF50; /* Green */
         border: none;
         color: white;
         padding: 15px 32px;
         text-align: center;
         text-decoration: none;
         display: inline-block;
         border-radius: 8px;
         &.share {
            background-color: #80aaff; /* Green */
         }
         &.action {
            margin-left: 5px;
            padding: 5px 16px;
            background-color: #bfbfbf;
         }
      }
   }
}
</style>